/* eslint-disable */
// const openai = require('../openai/openaiConfig')
// const { fs } = require('fs')
const path = require('path')
const outputDirectory = path.resolve(__dirname, '..', 'outputs')
// fs.ensureDirSync(outputDirectory)
/*
function formatFilename (text, voice) {
  let formattedText = text.replace(/\s+/g, '_').substring(0, 60)
  return `${formattedText}-${voice}.mp3`
}
*/

function transcribeAudio(file) {
  return new Promise((resolve, reject) => {
    const apiKey = 'sk-proj-uwxa7oEyvILEgr2cKLynT3BlbkFJV3AwgO5izcfu9pmWB7Jc'; // Reemplaza con tu clave API de OpenAI
    const url = 'https://api.openai.com/v1/audio/transcriptions';

    const formData = new FormData();
    formData.append('file', file);
    formData.append('model', 'whisper-1');
    
    const requestOptions = {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${apiKey}`
      },
      body: formData
    };

    fetch(url, requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Error en la solicitud de transcripción: ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        resolve(data.text); // Resuelve la promesa con el texto transcrito
      })
      .catch(error => {
        console.error(`Error in transcribeAudio: ${error.message}`);
        reject(error); // Rechaza la promesa si hay un error
      });
  });
}


function generateTextAlgebraico(text) {
  return new Promise((resolve, reject) => { // Añadir esto
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + String('sk-proj-uwxa7oEyvILEgr2cKLynT3BlbkFJV3AwgO5izcfu9pmWB7Jc')
        },
        body: JSON.stringify({
          'model': 'gpt-4.5-preview', // 'gpt-4o',
          "messages": [
            {
              "role": "system",
              "content": `Dame solamente el texto corregido, ninguna otra palabra mas de aclaración. Corrige el contenido del texto '${text}' que te envío a formato de ajedrez Algebraico teniendo en cuenta también que los enroques cortos son O-O y el enroque largo O-O-O".
              `
            },
            {"role":"user","content": text}
          ],
          "temperature": 1,
          "max_tokens": 4096,
          "top_p": 1,
          "frequency_penalty": 0,
          "presence_penalty": 0
        })
      }

      fetch('https://api.openai.com/v1/chat/completions', requestOptions)
        .then(response => response.json())
        .then(data => {
          // window.alert(JSON.stringify(data)); // Esto probablemente quieras quitarlo o modificarlo para un entorno de producción
          resolve(data); // Resuelve la promesa con los datos
        }).catch(err => {
          console.log("No tienes mas tokens por hoy");
          reject(err); // Rechaza la promesa si hay un error
        });
    } catch (error) {
      console.error(`Error in generateText: [${error.type}] ${error.message}`);
      reject(error); // Asegúrate de rechazar la promesa si hay una excepción
    }
  });
}



function generateQuestion(text, pgn, conversation) {
  return new Promise((resolve, reject) => { // Añadir esto
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + String('sk-proj-uwxa7oEyvILEgr2cKLynT3BlbkFJV3AwgO5izcfu9pmWB7Jc')
        },
        body: JSON.stringify({
          'model': 'gpt-4.5-preview', // 'gpt-4o',
          "messages": [
            {
              "role": "system",
              "content": `Respondes al nombre de MainchessBot. Tus respuestas son cortas y siempre referidas al ajedrez.
              Nunca respondes a nada que no esté relacionado con el ajedrez.
              También puedes incluir temas relacionados con el ajedrez, como películas, comics, imágenes, webs y otros temas relacionados con el ajedrez.
              Responde siempre a preguntas relacionadas con este PGN. ${pgn} o con temas de ajedrez.
              Cuando devuelvas una partida siempre en formato PGN y el PGN siempre entre estos símbolos <<< y >>>
              Algunas informaciones útiles:
              **Reglas de FEN Correcto**:
              - **Tablero**: Se lee de fila 8 a 1, de izquierda a derecha.
              - **Piezas**: Blancas en mayúsculas (K=King, Q=Queen, R=Rook, B=Bishop, N=Knight, P=Pawn), negras en minúsculas (k, q, r, b, n, p).
              - **Casillas Vacías**: Usa números para indicar cantidad de casillas vacías (ej. "3" para tres casillas vacías).
              - **Separación de Filas**: Con "/".
              - **Fila Vacía Total**: Usa "8".
              - **Siempre 2 Reyes y No Juntos**.
              - **Formato Completo**: "Piezas turno enroque al-paso medio-movimientos turnos". Ejemplo: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1".
              Verifica siempre la legalidad de la posición y las reglas básicas del ajedrez.
              El formato PGN (Portable Game Notation en inglés) es utilizado por los programas informáticos de ajedrez para almacenar y gestionar partidas de ajedrez. Existen otros formatos pero este es el de uso más generalizado. Muchos programas de ajedrez reconocen el formato PGN, el cual ha llegado a ser popular debido a que es fácil de acceder a los datos por medio de editores ASCII ordinarios.
              Etiquetas de formato PGN
              Cada etiquetas comienza con un "[", y otro para "]" para cerrar.
              Para almacenar la información en el formato PGN es necesario dar siete etiquetas, el orden es el siguiente:
              Etiqueta	Traducción	Descripción
              Event	Evento	
              El nombre del torneo o de la competencia.
              Site              Lugar              El lugar donde se llevó a cabo el evento, Esto debe ser en formato "Ciudad, Región PAÍS", donde PAÍS es el código del mismo en tres letras de acuerdo a l código del Comité Olímpico Internacional. Cómo ejemplo: "México, D.F. MEX".
              Date              Fecha              La fecha de inicio de la partida. en formato AAAA.MM.DD. Cuando se desconocen los valores se utilizan "??".
              Round             Ronda              La ronda original de la partida.
              White             Blancas            El jugador de las piezas blancas, en formato "apellido, nombre".
              Black             Negras             El jugador de las negras en el mismo formato.
              Result            Resultado          El resultado del juego. Sólo puede tener cuatro posibles valores: "1-0" (las blancas ganaron), "0-1" (Las negras ganaron), "1/2-1/2" (Tablas), o "*" (cuando el juego está actualmente en disputa,  un jugador fallece durante la partida o la partida ha sido postergada).
              Muchos otros pares de etiquetas son definidos por los estándares, entre los que están:
              Time              tiempo              La hora en que el juego empezó en formato "HH:MM:SS" de tiempo local.
              Termination       fin                Da más detalles del fin del juego de ajedrez. Puede ser "abandono", "adjudicación" (resultado determinado por adjudicación de una tercera parte), "muerte", "emergencia", "normal", "infracción a las reglas", "tiempo acabado" o "no finalizado".
              FEN              Posición inicial del juego  La posición inicial del juego en notación de Forsyth-Edwards (del inglés Forsyth-Edwards Notation). Esta se utiliza para registrar juegos parciales, que empiezan en alguna posición determinada.Si se utiliza una etiqueta FEN entonces debe colocarse un par de etiquetas adicional llamado "SetUp" (inicialización) con un valor de "1".
              Texto de las jugadas
              El texto de las jugadas describe los movimientos realizados en el juego del ajedrez. Esto debe incluir indicadores del número de la jugada (un número seguido de cero o más puntos) y notación estándar algebraica (NEA). El texto de las jugadas en la mayoría de los casos, es simplemente la letra descriptiva de la pieza en inglés, una "x" si existe una captura, y el nombre algebraico de dos caracteres del escaque final a donde la pieza se desplazó. Las abreviaturas de las piezas en inglés son:
              K = (king) Rey
              Q = (queen) Dama
              R = (rook) Torre
              B = (bishop) Alfil
              N = (knight) Caballo
              P = (pawn) Peón
              Al peón se le da una abreviación vacía, pero en otros contextos su abreviación es "P". El nombre algebraico de cada escaque es el usual de la notación algebraica.
              Ambiguedad              En algunos casos lo anterior puede ser ambiguo; si es así, el nombre algebraico de la pieza, su numéro de fila, o el escaque exacto es colocado después del nombre de la pieza que se mueve (en este orden de preferencia). De esta forma, "Nge2" se refiere a un caballo que está en g y se mueve a e2.
              Enroque              El enroque corto en NEA se indica con "O-O" y el enroque largo con "O-O-O" (son letras mayúsculas y no números ceros).
              Promoción del peón              Una promoción de un peón se denota añadiendo un signo "=" seguido del nombre algebraico de la pieza a la que el peón se promueve. Si el movimiento genera un jaque, se añade el signo "+"; si el movimiento implica un jaque mate se añade el signo de numeral "#".
              Comentarios              Los comentarios deben ser añadidos ya sea con un ";" (un comentario de una sola línea) o con un "{" (que continuará hasta que aparece un "}".
              El resto de la conversación ha sido: ${conversation}`
            },
            {"role":"user","content": text}
          ],
          "temperature": 1,
          "max_tokens": 4096,
          "top_p": 1,
          "frequency_penalty": 0,
          "presence_penalty": 0
        })
      }

      fetch('https://api.openai.com/v1/chat/completions', requestOptions)
        .then(response => response.json())
        .then(data => {
          // window.alert(JSON.stringify(data)); // Esto probablemente quieras quitarlo o modificarlo para un entorno de producción
          resolve(data); // Resuelve la promesa con los datos
        }).catch(err => {
          console.log("No tienes mas tokens por hoy");
          reject(err); // Rechaza la promesa si hay un error
        });
    } catch (error) {
      console.error(`Error in generateText: [${error.type}] ${error.message}`);
      reject(error); // Asegúrate de rechazar la promesa si hay una excepción
    }
  });
}


function analisisPGN(text, pgn) {
  return new Promise((resolve, reject) => { // Añadir esto
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + String('sk-proj-uwxa7oEyvILEgr2cKLynT3BlbkFJV3AwgO5izcfu9pmWB7Jc')
        },
        body: JSON.stringify({
          'model': 'o1-preview',
          "messages": [
            {
              "role": "user",
              "content": `Respondes al nombre de MainchessBot. Tus respuestas son cortas y siempre referidas al ajedrez.
              Nunca respondes a nada que no esté relacionado con el ajedrez.
              También puedes incluir temas relacionados con el ajedrez, como películas, comics, imágenes, webs y otros temas relacionados con el ajedrez.
              Responde siempre a preguntas relacionadas con este PGN. ${pgn} o con temas de ajedrez.
              Cuando devuelvas una partida siempre en formato PGN y el PGN siempre entre estos símbolos <<< y >>>
              El lenguaje es para que lo entienda un niño o un joven que está aprendiendo a jugar o tiene un ELO de 1500 aproximadamente.
              `
            },
            {"role":"user","content": text}
          ],
          "temperature": 1,
          "top_p": 1,
          "frequency_penalty": 0,
          "presence_penalty": 0
        })
      }

      fetch('https://api.openai.com/v1/chat/completions', requestOptions)
        .then(response => response.json())
        .then(data => {
          // window.alert(JSON.stringify(data)); // Esto probablemente quieras quitarlo o modificarlo para un entorno de producción
          resolve(data); // Resuelve la promesa con los datos
        }).catch(err => {
          console.log("No tienes mas tokens por hoy");
          reject(err); // Rechaza la promesa si hay un error
        });
    } catch (error) {
      console.error(`Error in generateText: [${error.type}] ${error.message}`);
      reject(error); // Asegúrate de rechazar la promesa si hay una excepción
    }
  });
}

function generatePGN(text, pgn) {
  return new Promise((resolve, reject) => { // Añadir esto
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + String('sk-proj-uwxa7oEyvILEgr2cKLynT3BlbkFJV3AwgO5izcfu9pmWB7Jc')
        },
        body: JSON.stringify({
          'model': 'o1-preview',
          "messages": [
            {
              "role": "user",
              "content": `Respondes al nombre de MainchessBot. Tus respuestas son cortas y siempre referidas al ajedrez.
              Nunca respondes a nada que no esté relacionado con el ajedrez.
              También puedes incluir temas relacionados con el ajedrez, como películas, comics, imágenes, webs y otros temas relacionados con el ajedrez.
              Responde siempre a preguntas relacionadas con este PGN. ${pgn} o con temas de ajedrez.
              Cuando devuelvas una partida siempre en formato PGN y el PGN siempre entre estos símbolos <<< y >>>
              Algunas informaciones útiles:
              **Reglas de FEN Correcto**:
              - **Tablero**: Se lee de fila 8 a 1, de izquierda a derecha.
              - **Piezas**: Blancas en mayúsculas (K=King, Q=Queen, R=Rook, B=Bishop, N=Knight, P=Pawn), negras en minúsculas (k, q, r, b, n, p).
              - **Casillas Vacías**: Usa números para indicar cantidad de casillas vacías (ej. "3" para tres casillas vacías).
              - **Separación de Filas**: Con "/".
              - **Fila Vacía Total**: Usa "8".
              - **Siempre 2 Reyes y No Juntos**.
              - **Formato Completo**: "Piezas turno enroque al-paso medio-movimientos turnos". Ejemplo: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1".
              Verifica siempre la legalidad de la posición y las reglas básicas del ajedrez.
              El formato PGN (Portable Game Notation en inglés) es utilizado por los programas informáticos de ajedrez para almacenar y gestionar partidas de ajedrez. Existen otros formatos pero este es el de uso más generalizado. Muchos programas de ajedrez reconocen el formato PGN, el cual ha llegado a ser popular debido a que es fácil de acceder a los datos por medio de editores ASCII ordinarios.
              Etiquetas de formato PGN
              Cada etiquetas comienza con un "[", y otro para "]" para cerrar.
              Para almacenar la información en el formato PGN es necesario dar siete etiquetas, el orden es el siguiente:
              Etiqueta	Traducción	Descripción
              Event	Evento	
              El nombre del torneo o de la competencia.
              Site              Lugar              El lugar donde se llevó a cabo el evento, Esto debe ser en formato "Ciudad, Región PAÍS", donde PAÍS es el código del mismo en tres letras de acuerdo a l código del Comité Olímpico Internacional. Cómo ejemplo: "México, D.F. MEX".
              Date              Fecha              La fecha de inicio de la partida. en formato AAAA.MM.DD. Cuando se desconocen los valores se utilizan "??".
              Round             Ronda              La ronda original de la partida.
              White             Blancas            El jugador de las piezas blancas, en formato "apellido, nombre".
              Black             Negras             El jugador de las negras en el mismo formato.
              Result            Resultado          El resultado del juego. Sólo puede tener cuatro posibles valores: "1-0" (las blancas ganaron), "0-1" (Las negras ganaron), "1/2-1/2" (Tablas), o "*" (cuando el juego está actualmente en disputa,  un jugador fallece durante la partida o la partida ha sido postergada).
              Muchos otros pares de etiquetas son definidos por los estándares, entre los que están:
              Time              tiempo              La hora en que el juego empezó en formato "HH:MM:SS" de tiempo local.
              Termination       fin                Da más detalles del fin del juego de ajedrez. Puede ser "abandono", "adjudicación" (resultado determinado por adjudicación de una tercera parte), "muerte", "emergencia", "normal", "infracción a las reglas", "tiempo acabado" o "no finalizado".
              FEN              Posición inicial del juego  La posición inicial del juego en notación de Forsyth-Edwards (del inglés Forsyth-Edwards Notation). Esta se utiliza para registrar juegos parciales, que empiezan en alguna posición determinada.Si se utiliza una etiqueta FEN entonces debe colocarse un par de etiquetas adicional llamado "SetUp" (inicialización) con un valor de "1".
              Texto de las jugadas
              El texto de las jugadas describe los movimientos realizados en el juego del ajedrez. Esto debe incluir indicadores del número de la jugada (un número seguido de cero o más puntos) y notación estándar algebraica (NEA). El texto de las jugadas en la mayoría de los casos, es simplemente la letra descriptiva de la pieza en inglés, una "x" si existe una captura, y el nombre algebraico de dos caracteres del escaque final a donde la pieza se desplazó. Las abreviaturas de las piezas en inglés son:
              K = (king) Rey
              Q = (queen) Dama
              R = (rook) Torre
              B = (bishop) Alfil
              N = (knight) Caballo
              P = (pawn) Peón
              Al peón se le da una abreviación vacía, pero en otros contextos su abreviación es "P". El nombre algebraico de cada escaque es el usual de la notación algebraica.
              Ambiguedad              En algunos casos lo anterior puede ser ambiguo; si es así, el nombre algebraico de la pieza, su numéro de fila, o el escaque exacto es colocado después del nombre de la pieza que se mueve (en este orden de preferencia). De esta forma, "Nge2" se refiere a un caballo que está en g y se mueve a e2.
              Enroque              El enroque corto en NEA se indica con "O-O" y el enroque largo con "O-O-O" (son letras mayúsculas y no números ceros).
              Promoción del peón              Una promoción de un peón se denota añadiendo un signo "=" seguido del nombre algebraico de la pieza a la que el peón se promueve. Si el movimiento genera un jaque, se añade el signo "+"; si el movimiento implica un jaque mate se añade el signo de numeral "#".
              Comentarios              Los comentarios deben ser añadidos ya sea con un ";" (un comentario de una sola línea) o con un "{" (que continuará hasta que aparece un "}".
              `
            },
            {"role":"user","content": text}
          ],
          "temperature": 1,
          "top_p": 1,
          "frequency_penalty": 0,
          "presence_penalty": 0
        })
      }

      fetch('https://api.openai.com/v1/chat/completions', requestOptions)
        .then(response => response.json())
        .then(data => {
          // window.alert(JSON.stringify(data)); // Esto probablemente quieras quitarlo o modificarlo para un entorno de producción
          resolve(data); // Resuelve la promesa con los datos
        }).catch(err => {
          console.log("No tienes mas tokens por hoy");
          reject(err); // Rechaza la promesa si hay un error
        });
    } catch (error) {
      console.error(`Error in generateText: [${error.type}] ${error.message}`);
      reject(error); // Asegúrate de rechazar la promesa si hay una excepción
    }
  });
}

function generateText(text, pgn) {
  return new Promise((resolve, reject) => { // Añadir esto
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + String('sk-proj-uwxa7oEyvILEgr2cKLynT3BlbkFJV3AwgO5izcfu9pmWB7Jc')
        },
        body: JSON.stringify({
          'model': 'gpt-4.5-preview', // 'gpt-4o',
          "messages": [
            {
              "role": "system",
              "content": `Respondes al nombre de MainchessBot. Tus respuestas son cortas y siempre referidas al ajedrez.
              Nunca respondes a nada que no esté relacionado con el ajedrez.
              También puedes incluir temas relacionados con el ajedrez, como películas, comics, imágenes, webs y otros temas relacionados con el ajedrez.
              Responde siempre a preguntas relacionadas con este PGN. ${pgn} o con temas de ajedrez.
              Cuando devuelvas una partida siempre en formato PGN y el PGN siempre entre estos símbolos <<< y >>>
              Algunas informaciones útiles:
              **Reglas de FEN Correcto**:
              - **Tablero**: Se lee de fila 8 a 1, de izquierda a derecha.
              - **Piezas**: Blancas en mayúsculas (K=King, Q=Queen, R=Rook, B=Bishop, N=Knight, P=Pawn), negras en minúsculas (k, q, r, b, n, p).
              - **Casillas Vacías**: Usa números para indicar cantidad de casillas vacías (ej. "3" para tres casillas vacías).
              - **Separación de Filas**: Con "/".
              - **Fila Vacía Total**: Usa "8".
              - **Siempre 2 Reyes y No Juntos**.
              - **Formato Completo**: "Piezas turno enroque al-paso medio-movimientos turnos". Ejemplo: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1".
              Verifica siempre la legalidad de la posición y las reglas básicas del ajedrez.
              El formato PGN (Portable Game Notation en inglés) es utilizado por los programas informáticos de ajedrez para almacenar y gestionar partidas de ajedrez. Existen otros formatos pero este es el de uso más generalizado. Muchos programas de ajedrez reconocen el formato PGN, el cual ha llegado a ser popular debido a que es fácil de acceder a los datos por medio de editores ASCII ordinarios.
              Etiquetas de formato PGN
              Cada etiquetas comienza con un "[", y otro para "]" para cerrar.
              Para almacenar la información en el formato PGN es necesario dar siete etiquetas, el orden es el siguiente:
              Etiqueta	Traducción	Descripción
              Event	Evento	
              El nombre del torneo o de la competencia.
              Site              Lugar              El lugar donde se llevó a cabo el evento, Esto debe ser en formato "Ciudad, Región PAÍS", donde PAÍS es el código del mismo en tres letras de acuerdo a l código del Comité Olímpico Internacional. Cómo ejemplo: "México, D.F. MEX".
              Date              Fecha              La fecha de inicio de la partida. en formato AAAA.MM.DD. Cuando se desconocen los valores se utilizan "??".
              Round             Ronda              La ronda original de la partida.
              White             Blancas            El jugador de las piezas blancas, en formato "apellido, nombre".
              Black             Negras             El jugador de las negras en el mismo formato.
              Result            Resultado          El resultado del juego. Sólo puede tener cuatro posibles valores: "1-0" (las blancas ganaron), "0-1" (Las negras ganaron), "1/2-1/2" (Tablas), o "*" (cuando el juego está actualmente en disputa,  un jugador fallece durante la partida o la partida ha sido postergada).
              Muchos otros pares de etiquetas son definidos por los estándares, entre los que están:
              Time              tiempo              La hora en que el juego empezó en formato "HH:MM:SS" de tiempo local.
              Termination       fin                Da más detalles del fin del juego de ajedrez. Puede ser "abandono", "adjudicación" (resultado determinado por adjudicación de una tercera parte), "muerte", "emergencia", "normal", "infracción a las reglas", "tiempo acabado" o "no finalizado".
              FEN              Posición inicial del juego  La posición inicial del juego en notación de Forsyth-Edwards (del inglés Forsyth-Edwards Notation). Esta se utiliza para registrar juegos parciales, que empiezan en alguna posición determinada.Si se utiliza una etiqueta FEN entonces debe colocarse un par de etiquetas adicional llamado "SetUp" (inicialización) con un valor de "1".
              Texto de las jugadas
              El texto de las jugadas describe los movimientos realizados en el juego del ajedrez. Esto debe incluir indicadores del número de la jugada (un número seguido de cero o más puntos) y notación estándar algebraica (NEA). El texto de las jugadas en la mayoría de los casos, es simplemente la letra descriptiva de la pieza en inglés, una "x" si existe una captura, y el nombre algebraico de dos caracteres del escaque final a donde la pieza se desplazó. Las abreviaturas de las piezas en inglés son:
              K = (king) Rey
              Q = (queen) Dama
              R = (rook) Torre
              B = (bishop) Alfil
              N = (knight) Caballo
              P = (pawn) Peón
              Al peón se le da una abreviación vacía, pero en otros contextos su abreviación es "P". El nombre algebraico de cada escaque es el usual de la notación algebraica.
              Ambiguedad              En algunos casos lo anterior puede ser ambiguo; si es así, el nombre algebraico de la pieza, su numéro de fila, o el escaque exacto es colocado después del nombre de la pieza que se mueve (en este orden de preferencia). De esta forma, "Nge2" se refiere a un caballo que está en g y se mueve a e2.
              Enroque              El enroque corto en NEA se indica con "O-O" y el enroque largo con "O-O-O" (son letras mayúsculas y no números ceros).
              Promoción del peón              Una promoción de un peón se denota añadiendo un signo "=" seguido del nombre algebraico de la pieza a la que el peón se promueve. Si el movimiento genera un jaque, se añade el signo "+"; si el movimiento implica un jaque mate se añade el signo de numeral "#".
              Comentarios              Los comentarios deben ser añadidos ya sea con un ";" (un comentario de una sola línea) o con un "{" (que continuará hasta que aparece un "}".
              `
            },
            {"role":"user","content": text}
          ],
          "temperature": 1,
          "max_tokens": 4096,
          "top_p": 1,
          "frequency_penalty": 0,
          "presence_penalty": 0
        })
      }

      fetch('https://api.openai.com/v1/chat/completions', requestOptions)
        .then(response => response.json())
        .then(data => {
          // window.alert(JSON.stringify(data)); // Esto probablemente quieras quitarlo o modificarlo para un entorno de producción
          resolve(data); // Resuelve la promesa con los datos
        }).catch(err => {
          console.log("No tienes mas tokens por hoy");
          reject(err); // Rechaza la promesa si hay un error
        });
    } catch (error) {
      console.error(`Error in generateText: [${error.type}] ${error.message}`);
      reject(error); // Asegúrate de rechazar la promesa si hay una excepción
    }
  });
}

module.exports.analisisPGN = analisisPGN
module.exports.generateText = generateText
module.exports.generatePGN = generatePGN
module.exports.generateQuestion = generateQuestion
module.exports.transcribeAudio = transcribeAudio
module.exports.generateTextAlgebraico = generateTextAlgebraico

// module.exports = { generateSpeech }



// WEBPACK FOOTER //
// ./src/services/openaiutils.js